module.exports = __webpack_public_path__ + "static/media/lv2-2.21284971.mp3";